import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  Form,
  InputGroup,
  Row,
  Col,
  Button,
  Image,
  Modal,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Datepickericon from "../../assets/date-picker.svg";
import Loader from "../Loader/Loader";
import SideBar from "../SideBar/SideBar";
import BackButton from "../BackButton/BackButton";
import { EditEventApi } from "../API/Events/EditEventApi";
import { UpdateEventApi } from "../API/Events/UpdateEventApi";
import swal from "sweetalert";
// import { format, parse, isValid } from "date-fns";
import Cropper from "react-easy-crop";
import getCroppedImg from "../SideBar_6/cropImage";
import imageCompression from "browser-image-compression";

export const EditEvent = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const path = window.location.href;
  const endPath = path.split("/");
  const event_id = endPath[5].split("-");
  const evenId = event_id[0];

  // Form states
  const [eventName, setEventName] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [eventUrl, setEventUrl] = useState("");
  const [eventLocation, setEventLocation] = useState("");
  const [eventDescription, setEventDescription] = useState("");
  const [organizerName, setOrganizerName] = useState("");
  const [organizerEmail, setOrganizerEmail] = useState("");
  const [organizerContact, setOrganizerContact] = useState("");
  const [eventImage, setEventImage] = useState(null);
  const [imageError, setImageError] = useState("");
  const [isChangedImage, setIsChangedImage] = useState(0);
  const [presentEventImage, setPresentEventImage] = useState("");

  // Error states
  const [errors, setErrors] = useState({});

  // Image cropper states
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [rotation, setRotation] = useState(0);
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [showCropper, setShowCropper] = useState(false);
  const [prevImg, setPrevimg] = useState("");
  const [cropImg, setcropImg] = useState("");
  const [iscropImgEdited, setIscropImgEdited] = useState(false);
  const [imageType, setimageType] = useState("");

  const inputRef = useRef();

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const triggerFileSelectPopup = () => inputRef.current.click();

  const handleSetCropperImg = async (e) => {
    const imageFile = e.target.files[0];
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };

    try {
      const compressedFile = await imageCompression(imageFile, options);
      const compressedSize = compressedFile.size / 1024 / 1024;
      const baseval = await imageCompression.getDataUrlFromFile(compressedFile);

      if (!e.target.files[0].name.match(/\.(jpg|jpeg|png|gif|jfif)$/)) {
        setShowCropper(false);
        setPrevimg("");
        swal({
          title: "Error!",
          text: "Please select a valid image",
          icon: "error",
          button: "Ok",
        });
        console.log("file type error", setShowCropper);
      } else if (compressedSize > options.maxSizeMB) {
        swal({
          title: "Error!",
          text: `File too Big, please select a file less than ${options.maxSizeMB}MB`,
          icon: "error",
          button: "Ok",
        });
      } else {
        setShowCropper(true);
        setPrevimg(URL.createObjectURL(compressedFile));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const modelClose = () => {
    setShowCropper(false);
    setZoom(1);
    setRotation(0);
  };

  const showCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        prevImg,
        croppedAreaPixels,
        rotation
      );
      setcropImg(croppedImage);
      setImageError("");
      setIscropImgEdited(true);
      setShowCropper(false);
      setZoom(1);
      setRotation(0);
      const imgType = croppedImage.split(";");
      const imgTypeData = imgType[0].split("/");
      setimageType(imgTypeData[1]);

      // Convert cropped image to file for submission
      const response = await fetch(croppedImage);
      const blob = await response.blob();
      const file = new File([blob], "event-logo.png", { type: "image/png" });
      setEventImage(file);
      setIsChangedImage(1);
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixels, rotation, prevImg]);

  useEffect(() => {
    getEditEventData();
  }, [evenId]);

  const getEditEventData = async () => {
    setLoading(true);
    const payload = { event_id: evenId };
    const res = await EditEventApi(payload);

    if (res.status === 200) {
      const data = res.data[0];
      setEventName(data.event_name);
      setOrganizationName(data.organization_name);
      setStartDate(new Date(data.event_start_date));
      setEndDate(new Date(data.event_end_date));
      setEventUrl(data.event_links);
      setEventLocation(data.event_location);
      setEventDescription(data.event_description);
      setOrganizerName(data.organizer_name);
      setOrganizerEmail(data.organizer_email);
      setOrganizerContact(data.organizer_contact);
      setPresentEventImage({ data: data.event_logo, file_type: "png" });
      setcropImg(data.event_logo);
    } else {
      swal({ text: res.message, icon: "error", buttons: "OK" });
    }
    setLoading(false);
  };

  const formatDateToYMD = (date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, "0");
    const day = `${date.getDate()}`.padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!eventName.trim()) newErrors.eventName = "Please enter event name!";
    if (!organizationName.trim())
      newErrors.organizationName = "Please enter organization name!";
    if (!startDate) newErrors.startDate = "Please select start date!";
    if (!endDate) newErrors.endDate = "Please select end date!";
    if (!eventUrl.trim()) newErrors.eventUrl = "Please enter event URL!";
    if (!eventLocation.trim())
      newErrors.eventLocation = "Please enter event location!";
    if (!eventDescription.trim())
      newErrors.eventDescription = "Please enter event description!";
    if (!organizerName.trim())
      newErrors.organizerName = "Please enter organizer's name!";
    if (!organizerEmail.trim())
      newErrors.organizerEmail = "Please enter organizer's email!";
    if (!organizerContact.trim())
      newErrors.organizerContact = "Please enter organizer's phone!";

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    let eventLogo = {
      data: "",
      file_type: "",
    };

    if (isChangedImage === 1 && cropImg) {
      // Extract base64 data from cropped image
      const base64Data = cropImg.split(",")[1]; // Remove the data:image/... prefix
      eventLogo = {
        data: base64Data,
        file_type: imageType || "png",
      };
    }

    setLoading(true);
    const payload = {
      event_id: parseInt(evenId),
      event_name: eventName,
      organization_name: organizationName,
      event_start_date: formatDateToYMD(new Date(startDate)),
      event_end_date: formatDateToYMD(new Date(endDate)),
      event_links: eventUrl,
      event_location: eventLocation,
      event_description: eventDescription,
      organizer_name: organizerName,
      organizer_email: organizerEmail,
      organizer_contact: organizerContact,
      event_logo: isChangedImage === 1 ? eventLogo : presentEventImage,
      is_image_changed: isChangedImage,
    };
    console.log("payload", payload);
    const res = await UpdateEventApi(payload);
    setLoading(false);

    swal({
      text: res.message,
      icon: res.status === 200 ? "success" : "warning",
      buttons: "OK",
    }).then(() => {
      if (res.status === 200) navigate("/events-list/all-events");
    });
  };

  const handleCancel = () => navigate("/events-list/all-events");

  const handleRemoveImage = () => {
    setcropImg("");
    setEventImage(null);
    setPresentEventImage({ data: "", file_type: "" });
    setIsChangedImage(1);
  };

  return (
    <>
      {loading && <Loader />}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <p className="page-maintitle">Edit Event</p>
          <div className="acc-dashboard mt-4">
            <Form className="formmain mx-0 mt-4 signin-row profile-form pb-4">
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Event Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={eventName}
                      onChange={(e) => setEventName(e.target.value)}
                    />
                    {errors.eventName && (
                      <p className="text-danger">{errors.eventName}</p>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Organization Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={organizationName}
                      onChange={(e) => setOrganizationName(e.target.value)}
                    />
                    {errors.organizationName && (
                      <p className="text-danger">{errors.organizationName}</p>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Start Date <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        className="form-control"
                        dateFormat="dd MMM yyyy"
                      />
                      <Image
                        src={Datepickericon}
                        className="date-picker-icon"
                      />
                    </InputGroup>
                    {errors.startDate && (
                      <p className="text-danger">{errors.startDate}</p>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      End Date <span className="text-danger">*</span>
                    </Form.Label>
                    <InputGroup>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        className="form-control"
                        dateFormat="dd MMM yyyy"
                        minDate={startDate}
                      />
                      <Image
                        src={Datepickericon}
                        className="date-picker-icon"
                      />
                    </InputGroup>
                    {errors.endDate && (
                      <p className="text-danger">{errors.endDate}</p>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group className="mb-4">
                    <Form.Label>
                      Event / Organization Logo (Optional)
                    </Form.Label>

                    {/* Image Upload Area */}

                    <div
                      className="imgsrc mt-2"
                      onClick={triggerFileSelectPopup}
                    >
                      <input
                        type="file"
                        accept="image/*"
                        ref={inputRef}
                        style={{ display: "none" }}
                        onChange={handleSetCropperImg}
                        onClick={(e) => (e.target.value = null)}
                      />
                      <div className="croppedImage">
                        {cropImg && !cropImg.includes("None") ? (
                          <div
                            style={{
                              position: "relative",
                              display: "inline-block",
                            }}
                          >
                            <img
                              src={cropImg}
                              className="logo_img_home"
                              style={{
                                width: "150px",
                                height: "150px",
                                objectFit: "cover",
                                borderRadius: "8px",
                                border: "1px solid #ddd",
                              }}
                              alt="Event logo"
                            />
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              style={{
                                position: "absolute",
                                top: "-10px",
                                right: "-10px",
                                borderRadius: "50%",
                                width: "25px",
                                height: "25px",
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleRemoveImage();
                              }}
                            >
                              ×
                            </button>
                          </div>
                        ) : (
                          <div className="imgsrcMain">
                            <div
                              style={{ textAlign: "center" }}
                              className="centerText"
                            >
                              <div
                                style={{
                                  width: "150px",
                                  height: "150px",
                                  border: "2px dashed #ddd",
                                  borderRadius: "8px",
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  cursor: "pointer",
                                }}
                              >
                                <span style={{ fontSize: "24px" }}>+</span>
                                <p
                                  style={{
                                    fontSize: "12px",
                                    margin: "5px 0 0 0",
                                  }}
                                >
                                  Click to upload logo
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* Cropper Modal */}
                    <Modal
                      show={showCropper}
                      onHide={modelClose}
                      style={{ marginTop: 0 }}
                      size="lg"
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>Crop Image</Modal.Title>
                      </Modal.Header>
                      <Modal.Body style={{ width: "100%", height: 400 }}>
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                          }}
                        >
                          <Cropper
                            image={prevImg}
                            crop={crop}
                            rotation={rotation}
                            zoom={zoom}
                            aspect={1 / 1} // Square aspect ratio for logos
                            showGrid={true}
                            onCropChange={setCrop}
                            onRotationChange={setRotation}
                            onCropComplete={onCropComplete}
                            onZoomChange={setZoom}
                          />
                        </div>
                      </Modal.Body>
                      <Modal.Footer className="modelFooter">
                        <button
                          className="close_btn_cropper"
                          onClick={modelClose}
                        >
                          Cancel
                        </button>
                        <button
                          className="green-btn mt-0 btn btn-primary"
                          onClick={showCroppedImage}
                        >
                          Save
                        </button>
                      </Modal.Footer>
                    </Modal>

                    {imageError && <p className="text-danger">{imageError}</p>}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Organizer Name <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={organizerName}
                      onChange={(e) => setOrganizerName(e.target.value)}
                    />
                    {errors.organizerName && (
                      <p className="text-danger">{errors.organizerName}</p>
                    )}
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>
                      Phone <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={organizerContact}
                      onChange={(e) => setOrganizerContact(e.target.value)}
                    />
                    {errors.organizerContact && (
                      <p className="text-danger">{errors.organizerContact}</p>
                    )}
                  </Form.Group>
                  <Form.Group className="mt-2">
                    <Form.Label>
                      Organizer Email <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      value={organizerEmail}
                      onChange={(e) => setOrganizerEmail(e.target.value)}
                    />
                    {errors.organizerEmail && (
                      <p className="text-danger">{errors.organizerEmail}</p>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Event URL <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={eventUrl}
                      onChange={(e) => setEventUrl(e.target.value)}
                    />
                    {errors.eventUrl && (
                      <p className="text-danger">{errors.eventUrl}</p>
                    )}
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>
                      Location <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      value={eventLocation}
                      onChange={(e) => setEventLocation(e.target.value)}
                    />
                    {errors.eventLocation && (
                      <p className="text-danger">{errors.eventLocation}</p>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col>
                  <Form.Group>
                    <Form.Label>
                      Event Description <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      as="textarea"
                      value={eventDescription}
                      onChange={(e) => setEventDescription(e.target.value)}
                      rows={6}
                    />
                    {errors.eventDescription && (
                      <p className="text-danger">{errors.eventDescription}</p>
                    )}
                  </Form.Group>
                </Col>
              </Row>

              <div className="d-flex justify-content-between mt-4">
                <Button
                  className="discard_btn"
                  variant="secondary"
                  onClick={handleCancel}
                >
                  Discard
                </Button>
                <Button
                  className="green-btn mt-3 update-Btn"
                  variant="primary"
                  onClick={handleSubmit}
                >
                  Update
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};
